import { Component, computed, inject, OnInit, signal } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { AdaaHelper } from "../../../../core/utils";
import { noWhitespaceValidator } from "../../../../core/validators";
import { FileInputType, PageMode } from "../../../constants/enums";
import { AttachFile, IntpCountrySectorModel } from "../../../models";
import { FormInputComponent, FormInputFileComponent } from "../../form";

@Component({
  selector: "adaa-intp-country-sector-modal",
  imports: [TranslatePipe, ReactiveFormsModule, FormInputComponent, FormInputFileComponent],
  templateUrl: "./intp-country-sector-modal.html",
  styleUrl: "./intp-country-sector-modal.scss",
})
export class IntpCountrySectorModalComponent implements OnInit {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _toastrService = inject(ToastrService);
  private readonly _translateService = inject(TranslateService);
  readonly modal = inject(NgbActiveModal);

  //Inputs
  pageMode = signal<PageMode>(PageMode.create);
  sector = signal<IntpCountrySectorModel | undefined>(undefined);

  //Props
  model: FormGroup;
  submitted = false;
  allowedFiles: FileInputType[] = [
    FileInputType.bmp,
    FileInputType.jpeg,
    FileInputType.jpg,
    FileInputType.png,
    FileInputType.svg,
  ];

  isViewMode = computed(() => this.pageMode() === PageMode.view);

  public get getImage(): AttachFile {
    const logo = this.model.get("iconId")?.value;
    const filename = this.model.get("filename")?.value;

    return {
      id: logo,
      filename: filename,
    };
  }

  public get displayLabel(): string {
    const nameEN = this.model.get("nameEN")?.value;
    const nameAE = this.model.get("nameAE")?.value;

    return AdaaHelper.getPageLabel(nameAE, nameEN);
  }

  public ngOnInit(): void {
    this.model = this._prepareForm();

    const sector = this.sector();
    if (sector) {
      this.model.patchValue(sector);
      this.model
        .get("filename")
        ?.setValue(AdaaHelper.isDefinedAndNotEmpty(sector.filename) ? sector.filename : sector.icon?.filename);
    }
  }

  public onFilechange(event: AttachFile | null) {
    this.model.get("iconId")?.setValue(event?.id);
    this.model.get("filename")?.setValue(event?.filename);
  }

  public save() {
    this.submitted = true;

    if (!this.model.valid) {
      this._toastrService.warning(this._translateService.instant("notification.warning.missing_info"));
      return;
    }

    this.modal.close(this.model.getRawValue());
  }

  private _prepareForm() {
    return this._formBuilder.group({
      id: null,
      fakeId: null,
      countryId: null,
      nameAE: [{ value: null, disabled: this.isViewMode() }, [Validators.required, noWhitespaceValidator()]],
      nameEN: [{ value: null, disabled: this.isViewMode() }, [Validators.required, noWhitespaceValidator()]],
      iconId: { value: null, disabled: this.isViewMode() },
      filename: null,
      updateUser: null,
    });
  }
}
